<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" epub:type="titlepage" id="_idContainer000">
<h1 class="TitlePg1">Let’s Brunch</h1>
<h2 class="TitlePg2">100 Recipes for the Best Meal of the Week</h2>
<h3 class="TitlePg3">Belinda Smith-Sullivan</h3>
<p class="TitlePg4">Photographs by Susan Barnson Hayward</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer001">
<img alt="Gibbs Smith logo" class="_idGenObjectAttribute-1" src="image/logo.jpg"/>
</div>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer002">
<img alt="Photo of Blueberry-Almond Puff Tarts." class="_idGenObjectAttribute-1" src="image/Brunch-Blueberry_Tarts-2-6-C.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" epub:type="dedication" id="_idContainer003">
<p class="dedication ParaOverride-1">To my husband Dan with all my love, respect, and admiration.</p>
</div>
<div class="Basic-Text-Frame" epub:type="copyright-page" id="_idContainer004">
<p class="CIP">Digital Edition 1.0</p>
<p class="CIP nospace">Text © 2020 Belinda Smith-Sullivan</p>
<p class="CIP nospace">Photographs © 2020 Susan Barnson Hayward</p>
<p class="CIP nospace">Author Photograph by Adrion Bell</p>
<p class="CIP">Food Styling by Corrine Miller</p>
<p class="CIP">All rights reserved. No part of this book may be reproduced by any means whatsoever without written permission from the publisher, except brief portions quoted for purpose of review.</p>
<p class="CIP nospace">Published by</p>
<p class="CIP nospace">Gibbs Smith</p>
<p class="CIP nospace">P.O. Box 667</p>
<p class="CIP">Layton, Utah 84041</p>
<p class="CIP nospace">1.800.835.4993 orders</p>
<p class="CIP">www.gibbs-smith.com</p>
<p class="CIP">Library of Congress Control Number: 2020933152</p>
<p class="CIP">ISBN: 978-1-4236-5536-7 (e-book)</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="Basic-Graphics-Frame" id="_idContainer005">
<img alt="Photo of a fried egg in a cast-iron skillet." class="_idGenObjectAttribute-2" src="image/Brunch-Croque_Extra-1_B.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lets-Brunch-Interiors_D.vue?358e86a6